let settings = {
    hideWarning: true
}

export default function general(){
    if(settings.hideWarning){
        console.warn = () => {

        };
    }
};